import Vue from 'vue'
import babelPolyfill from 'babel-polyfill'
import AuthService from '../services/AuthService.js'
import AuthAPIService from '../services/AuthApiService.js'
import Router from 'vue-router'
import cryptoJs from '../services/CryptoJsService';


// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/pages/Login');
const ConfirmarDatos = () => import('@/views/pages/Register');
const Page404 = () => import('@/views/pages/Page404');
const Page403 = () => import('@/views/pages/Page403');
const Dashboard = () => import('@/views/Dashboard');
const PagoWeb = () => import('@/views/pagos/Checkout');

const Eventos = () => import('@/views/eventos/Listado');
const EventoForm = () => import('@/views/eventos/Evento');
const EventoConfig = () => import('@/views/eventos/EventoConfig');
const EventosCategoria = () => import('@/views/eventos/EventosPorCategoria');
const EventoDetalle = () => import('@/views/eventos/EventoDetalle');
const EventoInscritos = () => import('@/views/eventos/EventoInscritos');
const EventosBoletos = () => import('@/views/eventos/Boletos');
const EventosFavoritos = () => import('@/views/eventos/Favoritos');

const Ponentes = () => import('@/views/ponentes/Listado');
const PonenteForm = () => import('@/views/ponentes/Ponente');

const Areas = () => import('@/views/areas/Listado');
const AreaForm = () => import('@/views/areas/Area');

const TiposEvento = () => import('@/views/tiposEvento/Listado');
const TipoEventoForm = () => import('@/views/tiposEvento/TipoEvento');

const Categorias = () => import('@/views/categorias/Listado');
const CategoriaForm = () => import('@/views/categorias/Categoria');

const Usuarios = () => import('@/views/usuarios/Listado');
const UsuarioForm = () => import('@/views/usuarios/Usuario');

const Campus = () => import('@/views/campus/Listado');
const CampusForm = () => import('@/views/campus/Campus');
const CampusStripeForm = () => import('@/views/campus/ClaveStripe');

const Noticias = () => import('@/views/noticias/Listado');
const NoticiaForm = () => import('@/views/noticias/Noticia');

const Promociones = () => import('@/views/promociones/Listado');
const PromocionForm = () => import('@/views/promociones/Promocion');

const ConfiguracionForm = () => import('@/views/configuracion/Configuracion');

const Servicios = () => import('@/views/servicios/Listado');
const ServicioForm = () => import('@/views/servicios/Servicio');

const BIUEventos = () => import('@/views/apreu/Eventos');
const BIURecordatorios = () => import('@/views/apreu/Recordatorios');
const DiaMaestro = () => import('@/views/eventos-externos/DiaMaestro');
const Posada2024 = () => import('@/views/eventos-externos/Posada2024');
const Anuario2025 = () => import('@/views/eventos-externos/AnuarioFoto2025');

const perfilesValidosAdmin = [ 'Super Admin', 'Administrador' ];
const perfilesValidosGE = [ 'Super Admin', 'Administrador', 'Gestor de Eventos', 'APREU' ];
            
Vue.use(Router)

const router = new Router({
  mode: 'history',//'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '*',
      redirect: '/oops'
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        ignoreRouting: false,
        requiresAuth: false,
        redirectIfTokenAvailable: true,
      }
    },
    {
      path: '/oops',
      name: 'Page404',
      component: Page404
    },
    {
      path: '/no-autorizado',
      name: 'Page403',
      component: Page403
    },
    {
      path: '/posada-2024/registro',
      name: 'Posada2024',
      component: Posada2024,
      meta: {
        requiresAuth: false,
        ignoreRouting: true,
      },
    },
    {
      path: '/anuario-2025/registro',
      name: 'AnuarioFoto2025',
      component:Anuario2025,
      meta: {
        requiresAuth: true,
        ignoreRouting: false,
      }
    },
    {
      path: '/dia-del-maestro-2025/registro',
      name: 'DiaDelMaestro2025',
      component:DiaMaestro,
      meta: {
        requiresAuth: false,
        ignoreRouting: false,
      }
    },
    {
      path: '/',
      redirect: '/inicio',
      name: 'Vida Anáhuac',
      meta: {
        requiresAuth: true
      },
      component: TheContainer,
      children: [
        {
          path: '/inicio',
          name: 'Inicio',
          component: Dashboard,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/checkout',
          name: 'Página de pago',
          component: PagoWeb,
          beforeEnter: (to, from, next) => {
            if (to.query.ev == undefined) {
              next({ name: 'Page404' });
            }
            if (parseInt(cryptoJs.decrypt(to.query.ev), 10) < 1) {
              next({ name: 'Page404' });
            }
            next();
          }
        },
        {
          path: '/confirmar-datos',
          name: 'Confirmar datos',
          component: ConfirmarDatos,
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            apiService.getAccessToken().then(r => {
              if (r.user != null) {
                next('inicio');
              } 
              next();
            });
            
          }
        },    
        {
          path: '/configuracion',
          name: 'Configuración',
          component: ConfiguracionForm,
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (usuarioAPI.user.perfil != 'Administrador') {
              next({ name: 'Page404' });
            }
            next();
          }
        },
        {
          path: '/eventos-anahuac',
          redirect: '/eventos-anahuac',
          name: 'Eventos Anáhuac',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/eventos-anahuac',
              name: 'Búsqueda',
              component: EventosCategoria,
            },
            {
              path: '/evento-anahuac/show',
              name: 'Sobre el evento',
              component: EventoDetalle,
              beforeEnter: (to, from, next) => {
                if (to.query.ev == undefined) {
                  next({ name: 'Page404' });
                }
                if (parseInt(cryptoJs.decrypt(to.query.ev), 10) < 1) {
                  next({ name: 'Page404' });
                }
                next();
              }
            },
          ]
        },
        {
          path: '/eventos',
          redirect: '/eventos/listado',
          name: 'Eventos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/eventos/listado',
              name: 'Listado',
              component: Eventos,
              beforeEnter: (to, from, next) => {
                const apiService = new AuthAPIService();
                const usuarioAPI = apiService.getDataLocalStorage();
                if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
                  next({ name: 'Page404' });
                }
                next();
              }    
            },
            {
              path: '/evento/alta',
              name: 'Alta',
              component: EventoForm,
              beforeEnter: (to, from, next) => {
                const apiService = new AuthAPIService();
                const usuarioAPI = apiService.getDataLocalStorage();
                if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
                  next({ name: 'Page404' });
                }
                next();
              }    
            },
            {
              path: '/evento/editar/:id',
              name: 'Edición',
              component: EventoForm,
              beforeEnter: (to, from, next) => {
                const apiService = new AuthAPIService();
                const usuarioAPI = apiService.getDataLocalStorage();
                if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
                  next({ name: 'Page404' });
                }
                next();
              }    
            },
            {
              path: '/evento/configuracion/:id',
              name: 'Configuración',
              component: EventoConfig,
              beforeEnter: (to, from, next) => {
                const apiService = new AuthAPIService();
                const usuarioAPI = apiService.getDataLocalStorage();
                if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
                  next({ name: 'Page404' });
                }
                next();
              }    
            },
            {
              path: '/evento/inscritos',
              name: 'Inscritos al evento',
              component: EventoInscritos,
              beforeEnter: (to, from, next) => {
                if (to.query.ev == undefined) {
                  next({ name: 'Page404' });
                }
                if (parseInt(cryptoJs.decrypt(to.query.ev), 10) < 1) {
                  next({ name: 'Page404' });
                }
                const apiService = new AuthAPIService();
                const usuarioAPI = apiService.getDataLocalStorage();
                if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
                  next({ name: 'Page404' });
                }
                next();
              }
            },
            {
              path: '/mis-boletos',
              name: 'Mis boletos',
              component: EventosBoletos
            },
            {
              path: '/mis-favoritos',
              name: 'Mis favoritos',
              component: EventosFavoritos
            },
          ]
        },
        {
          path: '/ponentes',
          redirect: '/ponentes/listado',
          name: 'Ponentes',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/ponentes/listado',
              name: 'Listado',
              component: Ponentes
            },
            {
              path: '/ponente/alta',
              name: 'Alta',
              component: PonenteForm
            },
            {
              path: '/ponente/editar/:id',
              name: 'Edición',
              component: PonenteForm
            }
          ]
        },
        {
          path: '/areas',
          redirect: '/areas/listado',
          name: 'Áreas',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/areas/listado',
              name: 'Listado',
              component: Areas
            },
            {
              path: '/area/alta',
              name: 'Alta',
              component: AreaForm
            },
            {
              path: '/area/editar/:id',
              name: 'Edición',
              component: AreaForm
            }
          ]
        },
        {
          path: '/categorias',
          redirect: '/categorias/listado',
          name: 'Categorías',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/categorias/listado',
              name: 'Listado',
              component: Categorias
            },
            {
              path: '/categoria/alta',
              name: 'Alta',
              component: CategoriaForm
            },
            {
              path: '/categoria/editar/:id',
              name: 'Edición',
              component: CategoriaForm
            }
          ]
        },
        {
          path: '/tipos-de-evento',
          redirect: '/tipos-de-evento/listado',
          name: 'Tipos de evento',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/tipos-de-evento/listado',
              name: 'Listado',
              component: TiposEvento
            },
            {
              path: '/tipos-de-evento/alta',
              name: 'Alta',
              component: TipoEventoForm
            },
            {
              path: '/tipos-de-evento/editar/:id',
              name: 'Edición',
              component: TipoEventoForm
            }
          ]
        },
        {
          path: '/promociones',
          redirect: '/promociones/listado',
          name: 'Promociones',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/promociones/listado',
              name: 'Listado',
              component: Promociones
            },
            {
              path: '/promocion/alta',
              name: 'Alta',
              component: PromocionForm
            },
            {
              path: '/promocion/editar/:id',
              name: 'Edición',
              component: PromocionForm
            }
          ]
        },
        {
          path: '/usuarios',
          redirect: '/usuarios/listado',
          name: 'Usuarios',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosAdmin.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/usuarios/listado',
              name: 'Listado',
              component: Usuarios
            },
            {
              path: '/usuario/alta',
              name: 'Alta',
              component: UsuarioForm
            },
            {
              path: '/usuario/editar/:id',
              name: 'Edición',
              component: UsuarioForm
            }
          ]
        },
        {
          path: '/biu',
          redirect: '/biu/eventos',
          name: 'BIU Eventos',
          component: {
            render(c) { return c('router-view')}
          },
          beforeEach: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (usuarioAPI.user.perfil != 'Super Admin' && usuarioAPI.user.perfil != 'APREU') {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/biu/eventos',
              name: 'Eventos',
              component: BIUEventos
            },
            {
              path: '/biu/recordatorios',
              name: 'Recordatorios',
              component: BIURecordatorios
            }
          ]
        },
        {
          path: '/campus',
          redirect: '/campus/listado',
          name: 'Campus',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (usuarioAPI.user.perfil != 'Super Admin') {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/campus/listado',
              name: 'Listado',
              component: Campus
            },
            {
              path: '/campus/stripe/apikeys',
              name: 'Claves de API - Stripe',
              component: CampusStripeForm,
              beforeEnter: (to, from, next) => {
                if (to.query.cc == undefined || to.query.ic == undefined) {
                  next({ name: 'Page404' });
                }
                next();
              }
            },
            {
              path: '/campus/alta',
              name: 'Alta',
              component: CampusForm
            },
            {
              path: '/campus/editar/:id',
              name: 'Edición',
              component: CampusForm
            }
          ]
        },
        {
          path: '/servicios',
          redirect: '/servicios/listado',
          name: 'Servicios',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosAdmin.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/servicios/listado',
              name: 'Listado',
              component: Servicios
            },
            {
              path: '/servicio/alta',
              name: 'Alta',
              component: ServicioForm
            },
            {
              path: '/servicio/editar',
              name: 'Edición',
              component: ServicioForm,
              beforeEnter: (to, from, next) => {
                if (to.query.uuid == undefined) {
                  next({ name: 'Page404' });
                }
                if (parseInt(cryptoJs.decrypt(to.query.uuid), 10) < 1) {
                  next({ name: 'Page404' });
                }
                next();
              }
            }
          ]
        },
        {
          path: '/noticias',
          redirect: '/noticias/listado',
          name: 'Noticias',
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: (to, from, next) => {
            const apiService = new AuthAPIService();
            const usuarioAPI = apiService.getDataLocalStorage();
            if (!perfilesValidosGE.includes(usuarioAPI.user.perfil)) {
              next({ name: 'Page404' });
            }
            next();
          },
          children: [
            {
              path: '/noticias/listado',
              name: 'Listado',
              component: Noticias
            },
            {
              path: '/noticia/alta',
              name: 'Alta',
              component: NoticiaForm
            },
            {
              path: '/noticia/editar/:id',
              name: 'Edición',
              component: NoticiaForm
            }
          ]
        },
      ]
    },
    
  ]
}

function isGapTimePassed(date) {
  const lastDate = new Date(Number(date));
  const currentDate = new Date();

  const differenceInMillis = currentDate - lastDate;
  const fiveMinutesInMillis = 1 * 60 * 1000;

  return differenceInMillis > fiveMinutesInMillis;

}

router.beforeEach(async (to, from, next) => {

  let autorizacion = to.matched.some(record => record.meta.requiresAuth);
  let ignoreRouting = to.matched.some(record => record.meta.ignoreRouting);
  let redirect = to.matched.some(record => record.meta.redirectIfTokenAvailable);

  if((ignoreRouting || !autorizacion) && !redirect) {
    console.log('Route without auth requirement');
    next();
    return;
  }

  const waitingRedirectTime = localStorage.getItem("waiting");
  console.log(waitingRedirectTime, 'waitingRedirectTime');
  console.log('checking waiting redirect flag', !waitingRedirectTime ? new Date(): new Date(Number(waitingRedirectTime)));
  let timeout = null;
  if(waitingRedirectTime && !isGapTimePassed(waitingRedirectTime)) {
    console.log('waiting redirect');
    timeout = setTimeout(() => {
      window.location.reload();
    }, 30000);
    return;
  } else if (waitingRedirectTime && isGapTimePassed(waitingRedirectTime)){
    console.log('time gap passed, removing flag');
    localStorage.removeItem("waiting");
  }
  console.log('waiting redirect on false');
  
  const apiService = new AuthAPIService();
  console.log('Getting local data');
  const usuarioAPI = apiService.getDataLocalStorage();
  let isValidToken = false;

  if(usuarioAPI && usuarioAPI.access_token) {
    console.log('validating local data');
    isValidToken = await apiService.validateToken(usuarioAPI.access_token);
  }

  if(isValidToken) {
    console.log('local data valid');
    if(to.fullPath == '/login') {
      if(timeout) {
        clearTimeout(timeout);
      }
      next('inicio');
      return;
    }

    if(timeout) {
      clearTimeout(timeout);
    }
    next(); 
    return;
  }

  console.log('local data invalid, requesting new silent data');
  const accesTokenSilent = await apiService.getTokenSilent();
 
  if(accesTokenSilent && accesTokenSilent.accessToken) {
    console.log('silent data retrieved, saved to local');
    usuarioAPI.access_token = accesTokenSilent.accessToken;
    apiService.encryptLocalStorage(usuarioAPI);

    if(to.fullPath == '/login') {
      if(timeout) {
        clearTimeout(timeout);
      }

      next('inicio');
      return;
    }

    if(timeout) {
      clearTimeout(timeout);
    }
    next();
    return;
  }

  console.log('silent data invalid, requesting user action');
  localStorage.setItem("lastRoute", to.fullPath);
  localStorage.setItem("waiting", `${new Date().valueOf()}`);
  console.log(to.fullPath, 'last route to redirect');
  console.log('set waiting flag to next iteration');
  await apiService.acquireTokenRedirect();
  console.log('finish operation');
  if(timeout) {
    clearTimeout(timeout);
  }
  next();
});

export default router;
